module.exports = __webpack_public_path__ + "img/4.81b2ee4a.jpg";